import { z } from "zod";
import { FirestoreTimestampSchema } from "./firestore.js";
const DocumentMetadataSchema = z.object({
  title: z.string().describe("\uBB38\uC11C \uC81C\uBAA9"),
  createdAt: FirestoreTimestampSchema,
  updatedAt: FirestoreTimestampSchema,
  url: z.string().url().optional().nullable().describe("\uBB38\uC11C URL"),
  version: z.number().default(0).describe("\uBC84\uC804")
}).describe("\uBB38\uC11C \uBA54\uD0C0\uB370\uC774\uD130");
const DocumentSchema = z.object({
  /** 문서 ID */
  id: z.string(),
  metadata: DocumentMetadataSchema.optional().nullable(),
  pageContent: z.string(),
  embedding: z.array(z.number()).optional().nullable()
  // embedding: z.string(),
});
const DocumentFirestoreSchema = DocumentSchema.omit({
  id: true,
  embedding: true
});
export {
  DocumentFirestoreSchema,
  DocumentMetadataSchema,
  DocumentSchema
};
//# sourceMappingURL=documents.js.map